<table
  mat-table
  [dataSource]="data"
  multiTemplateDataRows
  class="mat-elevation-z2 table-mrb !mb-4">
  <ng-container matColumnDef="No">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="!text-center header-background w-num">
      #
    </th>
    <td mat-cell *matCellDef="let element" class="!text-center">
      {{ getIndex(element, data) }}
    </td>
  </ng-container>
  <ng-container matColumnDef="fechaAcuerdo">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="!text-center header-background">
      Fecha del acuerdo
    </th>
    <td mat-cell *matCellDef="let element" class="!text-center">
      @if
      (element.expanded||(acuerdoSeleccionado?.expanded&&acuerdoSeleccionado?.idFE===element.idFE))
      {
      <mat-icon class="gray-icon" (click)="picker.open()">today</mat-icon>

      <mat-form-field (click)="openPicker(picker, element)">
        <label for="fecha">
          @if (fechaSeleccionada=='') {
          {{ element.fechaAcuerdo | date : "dd-MM-yyyy" : "UTC" }}
          } @else {
          {{ fechaSeleccionada | date : "dd-MM-yyyy" : "UTC" }}
          }
        </label>
        <input
          style="display: none"
          [value]="
            fechaSeleccionada
              ? fechaSeleccionada
              : parseDate(element.fechaAcuerdo)
          "
          matInput
          [ngModel]="fechaSeleccionada"
          [matDatepicker]="picker"
          (dateChange)="onDateChange($event, element)" />
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      } @else {
      <div class="fechaAcuerdo">
        <mat-icon class="gray-icon">calendar_today</mat-icon>
        {{ element.fechaAcuerdo | date : "dd-MM-yyyy" : "UTC" }}
      </div>

      }
    </td>
  </ng-container>
  <ng-container matColumnDef="temas">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="!text-center header-background">
      Temas
    </th>
    <td mat-cell *matCellDef="let element" class="!text-center">
      {{ element.temas }}
    </td>
  </ng-container>

  <ng-container matColumnDef="archivoUnico">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="!text-center header-background ">
      Archivo Único
    </th>
    <td mat-cell *matCellDef="let element" class="!text-center">
      <mat-icon class="gray-icon no-margin !cursor-pointer" (click)="downloadPDF(element)"
        >note_add</mat-icon
      >
    </td>
  </ng-container>

  <ng-container matColumnDef="descargar">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="!text-center header-background">
      Descargas
    </th>
    <td mat-cell *matCellDef="let element" class="!text-center ">
      <mat-icon  mat-raised-button
      #tooltip="matTooltip"
      matTooltip="Descargar Archivos"
      matTooltipPosition="above"
      aria-label="Lista Temas"
      class="gray-icon  !p-0 !pr-4 !m-0 !mr-2 !cursor-pointer" (click)="getTemas(element, 1)"
        >download</mat-icon
      >
      <mat-icon  mat-raised-button
      #tooltip="matTooltip"
      matTooltip="Lista Temas"
      matTooltipPosition="above"
      aria-label="Lista Temas"
      class="gray-icon no-margin !cursor-pointer" (click)="getTemas(element, 2)"
        >view_list</mat-icon
      >
    </td>
  </ng-container>

  <ng-container matColumnDef="expand">
    <th
      class="!text-righ header-background"
      mat-header-cell
      *matHeaderCellDef
      aria-label="row actions  "></th>
    <td mat-cell *matCellDef="let element" class="!text-center">
      <button
        mat-icon-button
        aria-label="expand row"
        (click)="toggleRow(element)">
        @if
        (element.expanded||(acuerdoSeleccionado?.expanded&&acuerdoSeleccionado?.idFE===element.idFE))
        {
        <mat-icon>keyboard_arrow_up</mat-icon>
        } @else {
        <mat-icon>keyboard_arrow_down</mat-icon>
        }
      </button>
    </td>
  </ng-container>

  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <td
      class="row-detalle-tema"
      mat-cell
      *matCellDef="let element"
      [attr.colspan]="columnsToDisplayWithExpand.length">
      <div
        [@detailExpand]="
          element.expanded ||
          (acuerdoSeleccionado?.expanded &&
            acuerdoSeleccionado?.idFE === element.idFE)
            ? 'expanded'
            : 'collapsed'
        ">
        <div
          *ngIf="
            element.expanded ||
            (acuerdoSeleccionado?.expanded &&
              acuerdoSeleccionado?.idFE === element.idFE)
          ">
          <app-detalle-tema
            [temasAcuerdo]="temasAcuerdo"
            style="width: 100%"></app-detalle-tema>
          <app-nuevo-tema
            style="width: 100%"
            [acuerdo]="createAcuerdoFormGroup(element)"
            [temasAcuerdo]="temasAcuerdo"></app-nuevo-tema>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
  <tr
    mat-row
    *matRowDef="let element; columns: columnsToDisplayWithExpand"
    class="example-element-row"
    [class.example-expanded-row]="
      element.expanded ||
      (acuerdoSeleccionado?.expanded &&
        acuerdoSeleccionado?.idFE === element.idFE)
    "></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: ['expandedDetail']"
    class="example-detail-row"></tr>
</table>
